export default __webpack_public_path__ + "2ca4a608cbbf395c5d52b460c33d5eec.svg";